// extracted by mini-css-extract-plugin
export default {"select":"CitiesForecast_select__zxPpe","heading":"CitiesForecast_heading__7dQV7","light":"CitiesForecast_light__jKUtK","button":"CitiesForecast_button__lYm+K"};